const processInclude = require("base/js/util");

$(document).ready(() => {
  localStorage.removeItem('selectedSortingURL');
  processInclude(require("./search/search"));
});